import React, { CSSProperties, FC, useContext, useMemo } from "react";
import PickListContext from "src/context/pickListContext";
import { Checkbox } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";

interface IProps {
	value?: number[];
	onChange?: (enrollments: number[]) => void;
	style?: CSSProperties;
}

const CourseEnrollmentList: FC<IProps> = React.forwardRef<
	HTMLDivElement,
	IProps
>(({ value, onChange, style }, ref) => {
	const { pickListTypes, pickListItems } = useContext(PickListContext);

	//get the product picklist type id
	const productPickListTypeId = useMemo(() => {
		const productPickListType = pickListTypes.find(
			(item) => item.code === "Product"
		);
		if (!productPickListType) {
			throw new Error("Product pick list type not found");
		}
		return productPickListType.id!;
	}, [pickListTypes]);

	//get the product picklist items
	const productPickListItems = useMemo(() => {
		return pickListItems.filter(
			(item) =>
				item.pickListTypeId === productPickListTypeId && item.code !== "VITALS"
		);
	}, [pickListItems, productPickListTypeId]);

	const _onChange = (checkedValues: CheckboxValueType[]) => {
		if (onChange) {
			onChange(checkedValues as number[]);
		}
	};

	//convert the product picklist items to CheckboxOptionType for the Checkbox.Group
	const options = productPickListItems.map((item) => {
		return {
			label: item.description,
			value: item.id!,
		};
	});

	return (
		<div ref={ref} style={style}>
			<Checkbox.Group
				data-testid="course-enrollment-list"
				options={options}
				onChange={_onChange}
				value={value}
			/>
		</div>
	);
});

export default CourseEnrollmentList;
